var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":require("../../assets/not-found/group-avator.svg"),"alt":"Group Avatar"}}),_c('div',{staticClass:"not-found__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"not-found__content"},[_vm._v(_vm._s(_vm.content))])])
}
var staticRenderFns = []

export { render, staticRenderFns }